import { AfterViewInit, Component, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-print-proposal-dialog',
  templateUrl: './print-proposal-dialog.component.html',
  styleUrls: ['./print-proposal-dialog.component.scss']
})
export class PrintProposalDialogComponent implements  AfterViewInit {

  loading = true;
  src: string | null = null;
  documentId = "pdfProposalDocument"
  url: SafeResourceUrl;

  constructor(private domSanitizer: DomSanitizer, @Inject(MAT_DIALOG_DATA) public data: { url: string }, private dialogRef: MatDialogRef<PrintProposalDialogComponent>) {
    this.url = this.loadImage(data.url);
  }

  private loadImage(url: string): string | SafeResourceUrl {
    if (url === null) { return '' }
    if (url === undefined || url === null || url?.length < 1) { return ''; }
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngAfterViewInit(): void {

    setTimeout(() => {
      this.loading = false;      
    }, 100);
  }

  pdfLoaded() {
    this.printDocument();
  }

  printDocument() {
    if (this.loading) {
      return;
    }

    var doc = document.getElementById(this.documentId) as HTMLIFrameElement;
    if (doc == null) { console.error("Embedded Proposal PDF is null"); return; }

    // Doesn't appear like this check if working.  Added the check for when view is initalized. 
    if (typeof doc.contentWindow?.print === 'undefined') {
      setTimeout(() => {
        this.printDocument();
      }, (500));
    }
    else {
      doc.contentWindow.print();
    }

    // //Wait until PDF is ready to print    
    // if (typeof doc.print === 'undefined') {    
    //     setTimeout(function(){printDocument(documentId);}, 1000);
    // } else {
    //     doc.print();
    // }
  }

  close() {
    this.dialogRef.close();
  }
}
